export const STAFF_USER = 'STAFF_USER'
export const CALC = 'CALC'
export const REPORT = 'REPORT'
export const AGENCY = 'AGENCY'
export const TRAINING = 'TRAINING'
